import { carcassmodel } from "./carcassmodel";
import httpService from "../../components/service";
// import Vue from 'vue'

const newState = () => {
    return {
        componentSelected: null,
        workspace: null,
        outer: null,
        inner: null,
        header: null,
        footer: null,
        dividers: [],
        pitchXConstant: true,
        pitchYConstant: true,
        pitchsX: [],
        pitchsY: [],
        baseBoxes: [],
        clusters: []
    };
};

export const carcass = {
    namespaced: true,
    state: newState(),
    getters: {
        getComponentSelected(state) {
            return state.componentSelected;
        },

        getWorkspace(state) {
            return state.workspace;
        },

        getOuter(state) {
            return state.outer;
        },

        getInner(state) {
            return state.inner;
        },
        getHeader(state) {
            return state.header;
        },
        getFooter(state) {
            return state.footer;
        },

        getDividers(state) {
            return state.dividers;
        },

        getBaseBoxes(state) {
            return state.baseBoxes;
        },

        istPitchXConstant(state) {
            return state.pitchXConstant;
        },

        istPitchYConstant(state) {
            return state.pitchYConstant;
        },

        getPitchsX(state) {
            return state.pitchsX;
        },

        getPitchsY(state) {
            return state.pitchsY;
        },

        getComponentById: state => id => {
            let component = null;
            let type = carcassmodel.getType(id);
            switch (type) {
                case carcassmodel.TYPE_DIVIDER:
                    component = state.dividers.find(component => {
                        return component.id === id;
                    });
                    break;
                case carcassmodel.TYPE_BASEBOX:
                    component = state.baseBoxes.find(component => {
                        return component.id === id;
                    });
                    break;
                case carcassmodel.TYPE_PITCHX:
                    component = state.pitchsX.find(component => {
                        return component.id === id;
                    });
                    break;
                case carcassmodel.TYPE_PITCHY:
                    component = state.pitchsY.find(component => {
                        return component.id === id;
                    });
                    break;
                case carcassmodel.TYPE_OUTER:
                    component = state.outer;
                    break;
                case carcassmodel.TYPE_INNER:
                    component = state.inner;
                    break;
                case carcassmodel.TYPE_HEADER:
                    component = state.header;
                    break;
                case carcassmodel.TYPE_FOOTER:
                    component = state.footer;
                    break;
            }

            return !component ? null : component;
        },

        getChildren: state => cmp => {
            let type = cmp._type;
            let children = [];

            switch (type) {
                case carcassmodel.TYPE_OUTER:
                    // component = state.outer
                    children.push(state.inner);
                    children.push(state.header);
                    break;
                case carcassmodel.TYPE_INNER:
                    children.push(state.dividers);
                    children.push(state.pitchsX);
                    children.push(state.pitchsY);
                    // children.push(state.pi)
                    break;
            }

            return children;
        },

        getClusters(state) {
            return state.clusters;
        }
    },

    mutations: {
        SET_COMPONENT_SELECTED(state, component) {
            state.componentSelected = component;
        },

        SET_WORKSPACE(state, workspace) {
            state.workspace = workspace;
        },

        SET_OUTER(state, outer) {
            state.outer = outer;
        },

        SET_INNER(state, inner) {
            state.inner = inner;
        },
        SET_HEADER(state, header) {
            state.header = header;
        },
        SET_FOOTER(state, footer) {
            state.footer = footer;
        },

        SET_PROPERTY_COMPONENT_SELECTED(state, obj) {
            state.componentSelected[obj.property] = obj.value;
        },

        SET_PROPERTY_COMPONENT(state, obj) {
            // obj.object[obj.property] = obj.value
            // let pitch = state.pitchsX.find((pitchX) => {
            //     return pitchX.id === obj.object.id
            // })

            // console.log(pitch, '=================================')

            obj.object[obj.property] = obj.value;
        },

        ADD_DIVIDER(state, divider) {
            state.dividers.push(divider);
        },

        DELETE_DIVIDER(state, divider) {
            let index = state.dividers.indexOf(divider);
            state.dividers.splice(index, 1);
        },

        ADD_BASEBOX(state, baseBox) {
            state.baseBoxes.push(baseBox);
        },

        DELETE_BASEBOX(state, baseBox) {
            let index = state.baseBoxes.indexOf(baseBox);
            state.baseBoxes.splice(index, 1);
        },

        SET_PITCHX_CONSTANT(state, isConstant) {
            state.pitchXConstant = isConstant;
        },

        SET_PITCHY_CONSTANT(state, isConstant) {
            state.pitchYConstant = isConstant;
        },

        ADD_PITCHX(state, pitchx) {
            state.pitchsX.push(pitchx);
        },

        SET_PITCHX(state, pitchx) {
            if (state.pitchsX.length === 0) {
                // let p = Vue.get(0)
                // p.x = (pitchx.value)
                state.pitchsX.push(pitchx.value);
            } else {
                // Vue.set(state.pitchsX, pitchx.index, pitchx.value)
                // state.pitchsX[pitchx.index] = pitchx.value
                state.pitchsX.splice(pitchx.index, 1, pitchx.value);
            }
        },

        DELETE_PITCHX(state, pitchx) {
            let index = state.pitchsX.indexOf(pitchx);
            state.pitchsX.splice(index, 1);
        },

        ADD_PITCHY(state, pitchy) {
            state.pitchsY.push(pitchy);
        },

        SET_PITCHY(state, pitchY) {
            if (state.pitchsY.length === 0) {
                state.pitchsY.push(pitchY.value);
            } else {
                // state.pitchsY[0] = pitchY
                // Vue.set(state.pitchsY, pitchY.index, pitchY.value)
                state.pitchsY.splice(pitchY.index, 1, pitchY.value);
            }
        },

        DELETE_PITCHY(state, pitchY) {
            let index = state.pitchsY.indexOf(pitchY);
            state.pitchsY.splice(index, 1);
        },

        CLEAR_PITCHY(state) {
            state.pitchsY = [];
        },

        CLEAR_PITCHX(state) {
            state.pitchsX = [];
        },

        CLEAN_STATE(state) {
            // state = newState()
            let newState2 = newState();
            // console.log(state, newState2)
            Object.keys(state).forEach(prop => {
                state[prop] = newState2[prop];
            });
        },

        SET_CLUSTERS(state, clusters) {
            state.clusters = clusters;
        }
    },

    actions: {
        setComponentSelected(context, component) {
            context.commit("SET_COMPONENT_SELECTED", component);
        },

        setWorkspace(context, workspace) {
            context.commit("SET_WORKSPACE", workspace);
        },

        setOuter(context, outer) {
            context.commit("SET_OUTER", outer);
        },

        setInner(context, inner) {
            context.commit("SET_INNER", inner);
        },
        setHeader(context, header) {
            context.commit("SET_HEADER", header);
        },
        setFooter(context, footer) {
            context.commit("SET_FOOTER", footer);
        },

        setPropertyComponentSelected(context, obj) {
            context.commit("SET_PROPERTY_COMPONENT_SELECTED", obj);
        },

        setPropertyComponent(context, obj) {
            context.commit("SET_PROPERTY_COMPONENT", obj);
        },

        addDivider(context, divider) {
            context.commit("ADD_DIVIDER", divider);
        },

        deleteDivider(context, divider) {
            context.commit("DELETE_DIVIDER", divider);
        },

        addBaseBox(context, basebox) {
            context.commit("ADD_BASEBOX", basebox);
        },

        deleteBaseBox(context, basebox) {
            context.commit("DELETE_BASEBOX", basebox);
        },

        setPitchXConstant(context, isConstant) {
            context.commit("SET_PITCHX_CONSTANT", isConstant);
        },

        setPitchYConstant(context, isConstant) {
            context.commit("SET_PITCHY_CONSTANT", isConstant);
        },

        addPitchX(context, pitchX) {
            context.commit("ADD_PITCHX", pitchX);
        },

        setPitchX(context, pitchX) {
            context.commit("SET_PITCHX", pitchX);
        },

        deletePitchX(context, pitchX) {
            context.commit("DELETE_PITCHX", pitchX);
        },

        addPitchY(context, pitchY) {
            context.commit("ADD_PITCHY", pitchY);
        },

        setPitchY(context, pitchY) {
            context.commit("SET_PITCHY", pitchY);
        },

        deletePitchY(context, pitchY) {
            context.commit("DELETE_PITCHY", pitchY);
        },

        clearPitchsY(context) {
            context.commit("CLEAR_PITCHY");
        },

        clearPitchsX(context) {
            context.commit("CLEAR_PITCHX");
        },

        loadClusterByCarcassId(context, id) {
            return httpService.get(`/admin/displayers/${id}/templates`).then(res => {
                context.commit("SET_CLUSTERS", res);
                return res;
            });
        },

        loadCarcass(context, carcassData) {
            const { isNext, header, base, footer, front, dividers, isRegularHorizontal, isRegularVertical, steps } = carcassData;
            let workspace = carcassmodel.workspace();
            if (!isNext) {
                workspace.height = parseFloat(carcassData.heightExternal + base);
                workspace.width = parseFloat(carcassData.widthExternal);
            } else {
                workspace.height = parseFloat(carcassData.workspace_height);
                workspace.width = parseFloat(carcassData.workspace_width);
            }

            context.commit("SET_WORKSPACE", workspace);

            let outer = carcassmodel.outer(context.state.workspace);
            outer.height = carcassData.heightExternal;
            outer.width = carcassData.widthExternal;

            if (isNext) {
                outer.x = carcassData.xExternal;
                outer.y = carcassData.yExternal;
            }

            context.commit("SET_OUTER", outer);
            let baseBox;
            if (isNext) {
                carcassData.baseBoxes
                    .map(baseB => {
                        baseBox = carcassmodel.baseBox(context.state.workspace);
                        baseBox.height = baseB.height;
                        baseBox.width = baseB.width;
                        baseBox.x = baseB.x;
                        baseBox.y = baseB.y;
                        return baseBox;
                    })
                    .forEach(base => context.commit("ADD_BASEBOX", base));
            } else {
                if (base > 0 && carcassData.baseBoxes.length === 0) {
                    baseBox = carcassmodel.baseBox(context.state.workspace);
                    baseBox.height = base;
                    baseBox.width = outer.width;
                    baseBox.y = outer.y + outer.height;
                    context.commit("ADD_BASEBOX", baseBox);
                }
            }

            let inner = carcassmodel.inner(context.state.outer);
            inner.height = carcassData.heightInternal;
            inner.width = carcassData.widthInternal;

            if (isNext) {
                inner.x = parseFloat(carcassData.xInternal);
                inner.y = parseFloat(carcassData.yInternal);
            } else {
                let xInternal = (outer.width - inner.width) / 2;
                // let yInternal = (outer.height - inner.width) / 2
                inner.x = xInternal;
                inner.y = 0;
            }

            context.commit("SET_INNER", inner);

            let head = carcassmodel.header(outer);

            if (isNext) {
                head.height = header.height;
                head.width = header.width;
                head.x = header.x;
                head.y = header.y;
            } else {
                head.height = front;
                head.width = outer.width;
                context.commit("SET_PROPERTY_COMPONENT", { object: inner, property: "y", value: front });
            }

            context.commit("SET_HEADER", head);

            if (footer) {
                let foot = carcassmodel.footer(outer);
                foot.width = footer.width;
                foot.height = footer.height;
                foot.x = footer.x;
                foot.y = footer.y;
                context.commit("SET_FOOTER", foot);
            }

            if (isNext) {
                let divid;
                dividers
                    .map(divider => {
                        divid = carcassmodel.divider(inner);
                        divid.width = divider.width;
                        divid.height = divider.height;
                        divid.x = divider.x;
                        divid.y = divider.y;
                        return divid;
                    })
                    .forEach(div => context.commit("ADD_DIVIDER", div));
            }

            let pitchX, pitchY;
            context.commit("SET_PITCHX_CONSTANT", isRegularHorizontal);
            let stepX = steps.find(step => step.orientation === "horizontal");
            if (stepX) {
                if (isRegularHorizontal) {
                    pitchX = carcassmodel.pitchX(inner);
                    pitchX.x = stepX.length;
                    pitchX.repeat = isNext ? stepX.repeat : stepX.repeat - 1;
                    pitchX.xOrigin = stepX.origin;
                    pitchX.xEnd = stepX.end;
                    pitchX.constant = true;
                    context.commit("ADD_PITCHX", pitchX);
                } else {
                    let pitchXs = stepX.content;
                    pitchXs.forEach(pitch => {
                        pitchX = carcassmodel.pitchX(inner);
                        pitchX.x = pitch.x;
                        pitchX.constant = false;
                        context.commit("ADD_PITCHX", pitchX);
                    });
                }
            }

            context.commit("SET_PITCHY_CONSTANT", isRegularVertical);
            let stepY = steps.find(step => step.orientation === "vertical");
            if (stepY) {
                if (isRegularVertical) {
                    pitchY = carcassmodel.pitchX(inner);
                    pitchY.y = stepY.length;
                    pitchY.repeat = isNext ? stepY.repeat : stepY.repeat - 1;
                    pitchY.yOrigin = stepY.origin;
                    pitchY.yEnd = stepY.end;
                    pitchY.constant = true;
                    context.commit("ADD_PITCHY", pitchY);
                } else {
                    let pitchYs = stepY.content;
                    pitchYs.forEach(pitch => {
                        pitchY = carcassmodel.pitchY(inner);
                        pitchY.y = pitch.y;
                        pitchY.constant = false;
                        context.commit("ADD_PITCHY", pitchY);
                    });
                }
            }
        },

        load(context, id) {
            return httpService.get("/admin/displayers/" + id).then(res => {
                context.dispatch("loadCarcass", res);
                return res;
            });
        },

        cleanState(context) {
            context.commit("CLEAN_STATE");
        },

        saveCluster(context, obj) {
            let { config, id } = obj;
            return httpService.put(`/admin/displayers/${id}/config`, JSON.stringify(config));
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/planonext/carcass.js